import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor( ) { }

  ngOnInit() {
  }

  goToCloud() {
    window.open('https://cloud.enermodo.com', '_self');
  }
}
